import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./App.css";

export default function PageWithLoader() {
  const location = useLocation();
  useEffect(() => {
    const loader = document.getElementById("loader");

    // Show the loader when the page loads
    loader.style.display = "flex";

    // Simulate a delay to hide the loader (e.g., for API loading)
    setTimeout(() => {
      loader.style.display = "none";
    }, 1000); // Adjust the time (2000ms = 2 seconds) as needed
  }, [location]);

  return (
    <div id="loader" style={{ display: "none" }}>
      <div className="lds-hourglass"></div>
    </div>
  );
}
